import DateFnsUtils from '@date-io/date-fns';
import {Trans} from '@lingui/macro';
import {Button, MenuItem} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import useRole from 'components/GenericsHooks/useRoles';
import useUser from 'components/GenericsHooks/useUser';
import CustomAlert from 'components/grid-dx/alert';
import {Roles} from 'app/Constants';
import {course} from 'constants/url';
import {CourseSchema} from 'features/course/modal/Course';
import {i18n2} from 'features/i18n/i18n';
import {FastField, Field, Form, Formik} from 'formik';
import {TextField} from 'formik-material-ui';
import {KeyboardDatePicker} from 'formik-material-ui-pickers';
import authFetch from 'helpers/requests';
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import getCourseType from '../hooks/getCourseType';
import useLoadCourseById from '../hooks/useLoadCoursesWithEverything';
import CheckboxWithLabel from './CustomCheckBox';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: '1%',
    marginBottom: '2%',
  },
  title: {
    marginBottom: '2%',
    textAlign: 'center',
  },
}));

const EditCourseForm = ({id, noEdit, changeTypeCourse}) => {
  const classes = useStyles();
  const rol = useRole();
  const isAdmin =
    rol === Roles.AdminHSE || rol === Roles.AdminITPS || rol === Roles.AdminQA;
  const canEditName = noEdit && isAdmin;
  const token = useSelector((state) => state.authentication.user.token);
  const user = useUser();
  // const loadCourseType = useLoadCourseType(rol);
  const loadCourseById = useLoadCourseById(id);

  const [type, setType] = useState([]);
  const [message, setMessage] = React.useState({
    text: '',
    open: false,
    successful: false,
  });
  const [information, setInformation] = useState({
    iD_Course: '',
    doc_Number: '',
    iD_Type: '',
    company: '',
    name: '',
    score: '',
    included_capa_ini: false,
    version: '',
    dateVig: null,
    content: '',
    pass: '',
    user: '',
    reason: '',
  });

  useEffect(() => {
    loadCourseById()
      .then((data) => {
        if (data != null) {
          setInformation({
            iD_Course: id,
            doc_Number: data.doc_Number,
            iD_Type: data.iD_Type,
            company: data.company,
            name: data.name,
            version: data.version,
            score: data.score,
            dateVig: data.dateVig,
            content: data.content,
            included_capa_ini: data.included_capa_ini,
            pass: '',
            user: user,
            reason: '',
          });
        }
      })
      .catch(() => {});

    getCourseType(rol, token)
      .then((data) => {
        if (typeof data !== undefined) {
          setType(data);
        }
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, rol, token, user]);

  const submit = (values) => {
    const method = 'PUT';
    let info = {...values, rol: rol};
    if (info.dateVig === null) {
      info.dateVig = '';
    }
    info = JSON.stringify(JSON.stringify(info));
    return authFetch(
      `${course}`,
      {
        method: method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: info,
      },
      token,
    )
      .then((response) => {
        if (response.ok) {
          response.json().then((courses) => {
            changeTypeCourse(courses.iD_Type);
          });
          setMessage({
            text: i18n2._('Curso modificado correctamente'),
            open: true,
            successful: true,
          });
        } else {
          response
            .text()
            .then((message) =>
              setMessage({text: message, open: true, successful: false}),
            );
          setMessage({text: response.message, open: true});
        }
      })
      .catch((error) => console.log(error));
  };

  return (
    <Paper className={classes.paper} elevation={3}>
      <Typography variant="h5" className={classes.title}>
        {noEdit ? i18n2._('Información del curso') : i18n2._('Editando curso')}
      </Typography>
      {canEditName && (
        <Alert severity="warning" style={{marginBottom: '1%'}}>
          {i18n2._('El estado actual del curso solo permite editar el nombre.')}
        </Alert>
      )}
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Formik
          initialValues={information}
          enableReinitialize
          onSubmit={(values) => submit(values)}
          validationSchema={CourseSchema(true, true)}>
          {(formikProps) => {
            if (noEdit && !canEditName) formikProps.isSubmitting = true;
            return (
              <Form>
                <Grid container spacing={2}>
                  <Grid item md={1} xs={12}>
                    <Field
                      name="iD_Course"
                      component={TextField}
                      required
                      label={i18n2._('ID')}
                      fullWidth
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <Field
                      name="name"
                      required
                      component={TextField}
                      label={i18n2._('Nombre')}
                      fullWidth
                      variant="outlined"
                      disabled={noEdit && !canEditName}
                    />
                  </Grid>
                  <Grid item md={1} xs={12}>
                    <Field
                      name="version"
                      component={TextField}
                      required
                      label={i18n2._('Versión')}
                      fullWidth
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Field
                      name="doc_Number"
                      required
                      component={TextField}
                      label={i18n2._('Documento/Código')}
                      autoFocus
                      fullWidth
                      variant="outlined"
                      disabled={noEdit}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Field
                      name="iD_Type"
                      component={TextField}
                      select
                      required
                      label={i18n2._('Tipo')}
                      fullWidth
                      variant="outlined"
                      disabled={noEdit}>
                      {type.map((value) => {
                        return (
                          !value.Deleted && (
                            <MenuItem key={value.iD_Type} value={value.iD_Type}>
                              {value.name}
                            </MenuItem>
                          )
                        );
                      })}
                      {formikProps.values.iD_Type === 'PEO' && (
                        <MenuItem key="PEO" value="PEO" disabled={true}>
                          {noEdit
                            ? 'PEO'
                            : i18n2._('PEO (Obsoleto - Usar SOP)')}
                        </MenuItem>
                      )}
                    </Field>
                  </Grid>
                  <Grid item xs={5}>
                    <Field
                      name="company"
                      required
                      component={TextField}
                      label={i18n2._('Compañía')}
                      fullWidth
                      variant="outlined"
                      disabled={noEdit}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <Field
                      name="score"
                      required
                      component={TextField}
                      label={i18n2._('Puntaje mínimo')}
                      fullWidth
                      variant="outlined"
                      disabled={noEdit}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      name="content"
                      component={TextField}
                      label={i18n2._('Descripción')}
                      fullWidth
                      variant="outlined"
                      multiline
                      disabled={noEdit}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      name="dateVig"
                      component={KeyboardDatePicker}
                      label={i18n2._('Fecha de vigencia')}
                      fullWidth
                      inputVariant="outlined"
                      disableToolbar
                      variant="inline"
                      views={['year', 'month', 'date']}
                      format="dd/MM/yyyy"
                      disabled={noEdit}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      name="included_capa_ini"
                      type="checkbox"
                      component={CheckboxWithLabel}
                      noEdit={noEdit}
                      Label={{
                        label: i18n2._('Incluir en capacitacion inicial'),
                      }}
                      formikProps={formikProps}
                    />
                  </Grid>
                  {(!noEdit || canEditName) && (
                    <>
                      <Grid item xs={12}>
                        <Field
                          label={i18n2._('Reason')}
                          name={'reason'}
                          fullWidth
                          variant="outlined"
                          component={TextField}
                          validate={(value) => {
                            let error;
                            if (
                              typeof value !== 'undefined' &&
                              value.length === 0
                            ) {
                              error = i18n2._('Please provide a reason');
                            }
                            return error;
                          }}
                          multiline
                        />
                      </Grid>
                      <Grid item sm={6} xs={12} style={{padding: 20}}>
                        <Field
                          label={i18n2._('User')}
                          name={'user'}
                          variant="standard"
                          size="small"
                          fullWidth
                          component={TextField}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled={true}
                        />
                      </Grid>
                      <Grid item sm={6} xs={12} style={{padding: 20}}>
                        <FastField
                          label={i18n2._('Password')}
                          name={'pass'}
                          variant="standard"
                          size="small"
                          fullWidth
                          component={TextField}
                          type="password"
                          validate={(value) => {
                            let error;
                            if (
                              typeof value !== 'undefined' &&
                              value.length === 0
                            ) {
                              error = i18n2._('Please provide a password');
                            }
                            return error;
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <div
                          style={{textAlign: 'center', marginBottom: '10px'}}>
                          <Button
                            type="submit"
                            disabled={formikProps.isSubmitting}
                            variant="contained"
                            color="primary">
                            <Trans>Editar</Trans>
                          </Button>
                        </div>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Form>
            );
          }}
        </Formik>
      </MuiPickersUtilsProvider>
      <CustomAlert
        message={message.text}
        ms={1000}
        successful={message.successful}
        handleClose={() => setMessage((prev) => ({...prev, open: false}))}
        open={message.open}
      />
    </Paper>
  );
};

export default EditCourseForm;
